import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/SettingMultiLanguage';

const getSettingLanguageReducer = handleActions({
    [Actions.GetSettingLanguageRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetSettingLanguageReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetSettingLanguageFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.GetSettingLanguageInit]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const updateSettingLanguageReducer = handleActions({
    [Actions.UpdateSettingLanguageRequested]: (state) => ({
        ...state,
        isFetching: true,
        isSuccess: false,
    }),
    [Actions.UpdateSettingLanguageReceived]: (state) => ({
        ...state,
        isFetching: false,
        isSuccess: true,
    }),
    [Actions.UpdateSettingLanguageFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        isSuccess: false,
        errors: action.payload.errors,
    }),
    [Actions.UpdateSettingLanguageInit]: () => ({
        isFetching: false,
        isSuccess: false,
        errors: {},
    }),
}, {
    isFetching: false,
    isSuccess: false,
    errors: {},
});

export default combineReducers({
    getSettingLanguage: getSettingLanguageReducer,
    updateSettingLanguage: updateSettingLanguageReducer,
});
